/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `A` - 높음 (A)
 * `B` - 중간 (B)
 * `C` - 낮음 (C)
 */
export type TrackVersionType =
  (typeof TrackVersionType)[keyof typeof TrackVersionType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrackVersionType = {
  A: "A",
  B: "B",
  C: "C",
} as const;
